import {Component, OnInit} from '@angular/core';
import {RemitaRespondse, RemittaModel} from "../../models/remiteResponse.model";
import {ModalDismissReasons, NgbModal, NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";
import {ScriptService} from "../../Services/script-service.service";
import {RemitaPaymentService} from "../../Services/RemitaPaymentService";
import {environment} from "../../../environments/environment";
declare const RmPaymentEngine: any;
@Component({
  selector: 'app-demand-notice-payment',
  templateUrl: './demand-notice-payment.component.html',
  styleUrls: ['./demand-notice-payment.component.css']
})
export class DemandNoticePaymentComponent implements OnInit {
  paymentInfo: any;
  isLoading = false;
  remita: RemitaRespondse | any;
  interswitch: RemittaModel | any;
  processingPayment: Boolean = false;
  message: String = "";
  closeResult:string="";
  // remitaInlineKey= environment.remitaInLineKey;
  paymentResponse: any = {};
  paymentType?: string;
  public paymentTransactionHistory: any;
  validatePayment: Boolean = true;

  modalOptions:NgbModalOptions;

  getPaymentOption?: string;
  errorMessage: string | null = null;
  isLoadingInterswitch: boolean = true;

  constructor(
      private scriptService: ScriptService,
      private remitaPaymentService: RemitaPaymentService,
      private modalService:NgbModal) {
    this.paymentInfo = this.remitaPaymentService.paymentInfo;
  }

  generateRRR() {
    this.isLoading = true;
    this.remitaPaymentService.generateRRR(this.paymentInfo).subscribe(value => {

      this.remita = value;
      this.isLoading = false;
    }, error => {
      console.log(error);
    })
  }

  ngOnInit(): void {
    this.scriptService.loadScript('remita_inline').then(r => {
      this.generateRRR();
    });
  }

  private dismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  checkout(amount: PaymentCurrencyAmount, orderId: any) {

  }
}
